import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=e1817a92&scoped=true"
import script from "./AccordionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AccordionItem.vue?vue&type=style&index=0&id=e1817a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1817a92",
  null
  
)

export default component.exports